module.exports = __webpack_public_path__ + "static/media/lh-min.22ae7571.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/lh-min.svg
// module id = 684
// module chunks = 0